<template>
  <div class="wrapper-content w-100" :class="{'hide-dz-success': isHideDzSuccess}" id="decretos-new-or-edit">
    <h1>{{titulo}}</h1>
    <LmBreadcrumb v-if="showBreadcrumb" />
    <div v-if="!form.permiteGuardar" class="estado-decreto">
      <h2>{{form.titulo}}</h2>
      <a-steps v-if="stepsDirection === 'horizontal'" :current="form.steps.position" size="small">
        <a-step
          v-for="(item, index) in form.steps.items"
          :key="`step-${index}`"
          :title="item.title" :description="item.description"
        />
      </a-steps>
    </div>
    <LmForm ref="lmFormRef">
      <div class="row mt-n4" v-if="observaciones.items.length">
        <div class="col-12 mb-2">
          <b-button v-b-toggle.collapse-1 variant="primary" class="float-right observaciones-button">{{observacionesButtonText}}</b-button>
          <b-collapse
            id="collapse-1"
            class="mt-2 col-lg-4 col-12 position-absolute lm-collapse"
            @show="observacionesButtonText = 'Ocultar observaciones'"
            @hide="observacionesButtonText = 'Ver observaciones'"
            >
            <b-list-group>
              <b-list-group-item
              v-for="(observacion, index) in observaciones.items"
              :key="`observacion-${index}`"
              class="flex-column align-items-start">
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="mt-3 mb-1">{{observacion.d_usuario}}</h5>
                  <small>{{observacion.f_alta}}</small>
                </div>
                <p class="mb-1">
                  {{observacion.d_observacion}}
                </p>
              </b-list-group-item>
            </b-list-group>
          </b-collapse>
        </div>
      </div>

      <div v-if="form.permiteGuardar">
        <div class="row">
          <LmTextInput
            autofocus
            class="col-12"
            v-model="form.titulo"
            label="Título"
            :v="$v.form.titulo"
            />
        </div>
        <!--
        <hr>
        <h4>Tipo de Decreto</h4>
        <div class="row">
          <LmSuperPowerSelect
            class="col-6"
            :data="lmSuperPowerSelects.clasificacion.selectOptions"
            :tbColumns="lmSuperPowerSelects.clasificacion.tbColumns"
            label="Clasificación"
            title="clasificación"
            :v="$v.form.idClasificacion"
            @values="updateClasificacion($event)"
            :model="sanitizeModel(form.idClasificacion)"
          />
          <LmSuperPowerSelect
            class="col-6"
            :disabled="!lmSuperPowerSelects.subclasificacion.selectOptions.length"
            :data="lmSuperPowerSelects.subclasificacion.selectOptions"
            :tbColumns="lmSuperPowerSelects.subclasificacion.tbColumns"
            label="Subclasificación"
            title="Subclasificación"
            :v="$v.form.idSubclasificacion"
            @values="updateSubclasificacion($event)"
            :model="sanitizeModel(form.idSubclasificacion)"
          />
        </div> -->
        <h4>Corresponde a:</h4>
        <div
          v-for="(origen, index) in form.origenes"
          :key="`documento-${index}`"
          class="row">
          <!--
            Dejo esto aquí como referencia el código que se usa en el componente
            <LmSuperPowerSelect
            class="col-12 col-lg-6"
            :data="lmSuperPowerSelects.tipoDocumento.selectOptions"
            :tbColumns="lmSuperPowerSelects.tipoDocumento.tbColumns"
            label="Tipo Documento"
            placeholder="Tipo Documento"
            @values="updateTipoDocumento($event, index)"
            :model="sanitizeModel(form.origenes.length ? form.origenes[index].tipoDocumentoId : null)"
          /> -->
          <LmTreeSelect
          :label="$t('Tipo Documento')"
          :placeholder="$t('Tipo Documento')"
          :value="valueTipoDocumento(index)"
          @input="inputTipoDocumento(index, $event)"
          :options="lmSuperPowerSelects.tipoDocumento.selectOptions"
          class="col-12 col-lg-6"
          />
          <LmTextInput
            class="col-12 col-lg-4"
            v-model="form.origenes[index].numberDocumento"
            label="Número"
            placeholder="Número"
            />
          <button
            class="btn btn-link text-danger col-2"
            @click="form.origenes.splice(index, 1)"
            >
            <font-awesome-icon icon="trash" />
            <span class="ml-1">Eliminar</span>
          </button>
        </div>
        <LmButton
          id="new-document"
          type="button"
          :value="`Nueva Referencia`"
          @click.native="form.origenes.push({ tipoDocumentoId: '', numberDocumento: null })"
          buttonClass="btn-primary btn-sm"
          lmButtonWrapperClass="col-auto"
          lmButtonRootWrapperClass="d-inline-block mr-1"
        />
        <hr>
        <h4>Cuerpo Decreto</h4>
        <div class="row">
          <LmEditor
            ref="lmEditorSeccionVisto"
            class="col-12"
            @onUpdate="form.seccionVisto = $event"
            label="Visto"
            :v="$v.form.seccionVisto"
            :contentProps="form.seccionVisto"
            :activeTable="false"
          />
          <LmEditor
            ref="lmEditorSeccionConsiderando"
            class="col-12"
            @onUpdate="form.seccionConsiderando = $event"
            label="Considerando"
            :v="$v.form.seccionConsiderando"
            :contentProps="form.seccionConsiderando"
            :activeTable="false"
          />
        </div>
        <div class="row">
          <LmTextInput
            class="col-12"
            v-model="form.seccionFinal"
            :maxLength=256
            :disabled="true"
            />
        </div>
        <hr>
        <h4>Decreta</h4>
        <div
          v-for="(articulo, index) in form.articulos"
          :key="`decreta-${index}`"
          class="row">
          <LmEditor
            ref="lmEditor"
            class="col-10 col-lg-10"
            @onUpdate="form.articulos[index].articuloContent = $event"
            :label="`Art.${index + 1}º`"
            :v="$v.form.articulos.$each.$iter[index].articuloContent"
            :contentProps="form.articulos[index].articuloContent"
          />
          <button
            class="btn btn-link text-danger col-2 mt-5"
            @click="form.articulos.splice(index, 1)"
            :disabled="form.articulos.length <= 1"
            >
            <font-awesome-icon icon="trash" />
            <span class="ml-1">Eliminar Artículo</span>
          </button>
        </div>
        <LmButton
          id="new-article"
          type="button"
          value="Nuevo Artículo"
          @click.native="form.articulos.push({ articuloContent: '' })"
          buttonClass="btn-primary btn-sm"
          lmButtonWrapperClass="col-auto"
          lmButtonRootWrapperClass="d-inline-block mr-1"
        />
        <hr>
        <div class="row">
          <h4 class="col-12">Refrenda</h4>
          <!--
            Dejo esto aquí como referencia el código que se usa en el componente
            <LmSuperPowerSelect
            class="col-12"
            :data="lmSuperPowerSelects.refrenda.selectOptions"
            :tbColumns="lmSuperPowerSelects.refrenda.tbColumns"
            label="Secretaria"
            placeholder="Secretaria"
            :multiple="true"
            :model="sanitizeModel(form.refrenda)"
            :pageSize="20"
            @values="updateRefrenda($event)"
          /> -->
          <LmTreeSelect
          :label="$t('Secretaria')"
          :placeholder="$t('Secretaria')"
          v-model="refrenda"
          :multiple="true"
          :options="lmSuperPowerSelects.refrenda.selectOptions"
          @input="inputRefrenda($event)"
          class="col-12"
          />
        </div>
        <div v-if="form.permiteCompartir">
          <hr>
          <div class="form-check">
            <input
              v-model="form.compartir"
              type="checkbox"
              class="form-check-input"
              id="compartir"
              />
            <label class="form-check-label" for="compartir">Permitir compartir el decreto para seguimiento</label>
          </div>
        </div>
        <hr>
        <div class="row">
          <h4 class="col-12">Tome conocimiento</h4>
          <!--
            Dejo esto aquí como referencia el código que se usa en el componente
            <LmSuperPowerSelect
            class="col-12"
            :data="lmSuperPowerSelects.tomeConocimiento.selectOptions"
            :tbColumns="lmSuperPowerSelects.tomeConocimiento.tbColumns"
            label="Secretaria"
            placeholder="Secretaria"
            :multiple="true"
            :model="sanitizeModel(form.tomeConocimiento)"
            :pageSize="20"
            @values="updateTomeConocimiento($event)"
          /> -->
          <LmTreeSelect
          :label="$t('Secretaria')"
          :placeholder="$t('Secretaria')"
          v-model="tomeConocimiento"
          :multiple="true"
          :options="lmSuperPowerSelects.tomeConocimiento.selectOptions"
          class="col-12"
          @input="inputTomeConocimiento($event)"
          />
        </div>
        <hr>
        <div class="row">
          <h4 class="col-12">Anexos</h4>
        </div>
        <div class="row">
          <div class="col-12">
            <draggable
              tag="b-list-group"
              v-model="form.anexos"
              group="people"
              @start="drag=true"
              @end="drag=false"
              >
                <b-list-group-item
                  v-for="(file, index) in form.anexos"
                  :key="index"
                  class="d-flex justify-content-between"
                  >
                  <font-awesome-icon class="bar mr-2" icon="bars" />
                  <button
                    type="button"
                    v-b-modal.anexosModal
                    class="btn btn-link p-0  text-truncate text-left w-100"
                    @click="setAnexosModalFile(file)"
                    >{{file.originalname}}</button>
                  <div class="d-flex justify-content-end align-items-center">
                    <b-badge variant="primary file-size">{{ formatBytes(file.size) }}</b-badge>
                    <font-awesome-icon class="close ml-3" icon="times" @click="deleteUploadFile(index)"/>
                  </div>
                </b-list-group-item>
            </draggable>
          </div>
          <LmUploadFiles
            ref="lmUploadFiles"
            class="mb-3 col-12"
            :dropzoneOptions="dropzoneOptions"
            dictDefaultMessage='Arrastre el archivo pdf hasta aquí para subirlo'
            @vdropzone-removed-file="fileRemoved"
            @vdropzone-success="fileCreated"
            @vdropzone-error="dropzoneErrorHandler"
          />
          <div
            class="mb-3 col-12"
            >
            <b-alert
              v-for="(dropzoneError, index) in dropzoneErrors"
              :key='index'
              :show="5"
              :variant="dropzoneError.variant"
              @dismissed="dropzoneErrors.splice(index, 1)"
              fade
              >{{dropzoneError.message}}</b-alert>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div v-if="stepsDirection === 'vertical'" class="col-sm-12 col-md-2">
            <a-steps :current="form.steps.position" size="small" direction="vertical">
              <a-step
                v-for="(item, index) in form.steps.items"
                :key="`step-${index}`"
                :title="item.title" :description="item.description"
              />
            </a-steps>
          </div>
          <div :class="pdfViewerColumns">
            <iframe id="pdfViewer" v-if="form.PDFUrl" :src="form.PDFUrl" width="100%" :height="pdfViewerHeight"/>
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <!--
          Dejo esto aquí como referencia el código que se usa en el componente
          <LmSuperPowerSelect
          class="col-12"
          :data="lmSuperPowerSelects.tomeConocimiento.selectOptions"
          :tbColumns="lmSuperPowerSelects.tomeConocimiento.tbColumns"
          label="Tome Conocimiento - Secretaria"
          placeholder="Secretaria"
          :multiple="true"
          :model="sanitizeModel(form.tomeConocimiento)"
          :pageSize="20"
          @values="updateTomeConocimiento($event)"
          v-if="isOnEditMode"
          :disabled="true"
        /> -->
        <LmTreeSelect
        :label="$t('Tome Conocimiento - Secretaria')"
        :placeholder="$t('Secretaria')"
        :disabled="true"
        :value="tomeConocimiento"
        :multiple="true"
        :options="lmSuperPowerSelects.tomeConocimiento.selectOptions"
        class="col-12"
        v-if="isOnEditMode && !form.permiteGuardar"
        />
      </div>
      <div v-if="isOnEditMode && !form.permiteGuardar">
        <div class="form-check">
          <input
            v-model="form.compartir"
            type="checkbox"
            class="form-check-input"
            :disabled="true"
            id="compartir"
            />
          <label class="form-check-label" for="compartir">Permitir compartir el decreto para seguimiento</label>
        </div>
      </div>
      <hr>
      <LmButton
        id="btn-cancel"
        type="button"
        buttonClass="btn-secondary"
        :isProcessing="formIsProcessing"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
      />
      <LmButton
        id="btn-submit"
        type="submit"
        buttonClass="btn-primary"
        :isProcessing="formIsProcessing"
        :value="$t('Save')"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="save"
        v-if="form.permiteGuardar"
      />
      <LmButton
        id="btn-submit-enviar-a-visar"
        type="submit"
        buttonClass="btn-success"
        :isProcessing="formIsProcessing"
        value="Guardar y Enviar a Visar"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="enviaraVisar"
        v-if="form.permiteGuardar"
      />
      <LmButton
        id="btn-submit-enviar-a-firmar"
        type="submit"
        buttonClass="btn-success"
        :isProcessing="formIsProcessing"
        value="Guardar y Enviar a Firmar"
        lmButtonRootWrapperClass="d-inline-block mr"
        lmButtonWrapperClass="col"
        @click.native="enviaraFirmar"
        v-if="form.permiteGuardar"
      />
      <LmButton
        id="btn-submit-aprobar-visado"
        type="submit"
        buttonClass="btn-success"
        :isProcessing="formIsProcessing"
        value="Aprobar"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="aprobarVisado"
        v-if="form.permiteVisar && isOnEditMode"
      />
      <LmButton
        id="btn-submit-rechazar-visado"
        type="submit"
        buttonClass="btn-danger"
        :isProcessing="formIsProcessing"
        value="Rechazar"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="rechazarVisado"
        v-if="form.permiteVisar && isOnEditMode"
      />
      <LmButton
        id="btn-submit-firmar-via-firmador"
        type="submit"
        buttonClass="btn-success"
        :isProcessing="formIsProcessing"
        value="Firmar"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="firmarViaFirmador"
        v-if="form.permiteFirmar"
      />
      <LmButton
        id="btn-submit-rechazar-firmado"
        type="submit"
        buttonClass="btn-danger"
        :isProcessing="formIsProcessing"
        value="Rechazar"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="rechazarFirmado"
        v-if="form.permiteFirmar"
      />
      <LmButton
        id="btn-submit-tomar-control"
        type="submit"
        buttonClass="btn-danger"
        :isProcessing="formIsProcessing"
        value="Tomar Control"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="tomarControlDecreto"
        v-if="form.permiteTomarControl && !form.permiteGuardar"
      />
      <LmButton
        id="btn-submit-tomar-control"
        type="submit"
        buttonClass="btn-info"
        :isProcessing="formIsProcessing"
        value="Historial"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="goToMovementsBtn"
        v-if="form.permiteVerHistorial && !form.permiteGuardar"
      />
      <LmButton
        v-b-modal.pdfViewerModal
        id="btn-submit-vista-previa"
        type="submit"
        buttonClass="btn-info"
        :isProcessing="formIsProcessing"
        value="Vista Previa"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        v-if="form.permitePrevisualizar"
        @click="vistaprevia"
      />

    </LmForm>
    <lmConfirmationModal ref="lmConfirmationModalAprobar" title="Aviso" message="Va a enviar el decreto a firmar.  Está seguro?"/>
    <lmConfirmationModal ref="lmConfirmationModalVisado" title="Aviso" message="Va a enviar el decreto a Visado Interno.  Está seguro?"/>
    <lmConfirmationModal ref="lmConfirmationModalEnviaraFirmar" title="Aviso" message="Va a enviar el decreto a firmar.  Está seguro?"/>
    <lmConfirmationModal ref="lmConfirmationModalFirmar" title="Aviso" message="Va a iniciar el proceso de firma del decreto.  Está seguro?"/>
    <lmConfirmationModal ref="lmConfirmationModalTomarControl" title="Aviso" message="Esta por tomar control del decreto.  Está seguro?"/>
    <LmSuggestionModal
      ref="LmSuggestionModal"
      title="Motivo del Rechazo"
      info="<p>Escriba la observación sobre el presente decreto,<strong> tenga en cuenta que esta acción</strong> vuelve el decreto a Edición e <strong>invalida todas la firmas digitales previas</strong> si existen</p>"
      :textAreaSetup="{
        id: 'reason',
        label: 'Motivo',
        placeholder: 'Motivo'
      }"
    />
    <b-modal id="decretoPDFModal" title="Decreto PDF" size="lg" >
    </b-modal>
    <b-modal id="anexosModal" :title="anexosModalFile.name" size="xl" hide-footer >
      <iframe :src="anexosModalFile.src" frameborder="0" style="height:75vh;" width="100%"></iframe>
    </b-modal>
    <b-modal ref="pdfViewerModal" id="pdfViewerModal" size="huge" class="pdfViewerModal" hide-footer >
      <div class="text-center" v-if="!filePreview">
        <b-spinner label="Preview" variant="primary" />
        <div>Creando preview</div>
      </div>
      <iframe v-if="filePreview" :src="filePreview" width="100%" :height="pdfViewerHeight"/>
    </b-modal>
  </div>
</template>

<script>
import LmForm from '@/components/form/LmForm.vue'
import LmTextArea from '@/components/form/elements/LmTextArea.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import lmFormatBytes from '@/mixins/lmFormatBytes.js'
import lmToasts from '@/mixins/lmToasts.js'
import LmButton from '@/components/form/elements/LmButton'
import lmConfirmationModal from '@/components/modals/LmConfirmationModal'
import LmSuggestionModal from '@/components/modals/LmSuggestionModal'
import LmEditor from '@/components/form/elements/lmEditor'
import commonsApi from '@/api/commons'
import LmUploadFiles from '@/components/LmUploadFiles.vue'
import draggable from 'vuedraggable'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect.vue'
import _ from 'lodash'

import store from '@/store'
import { mapActions } from 'vuex'
import { required, requiredIf, maxLength, minLength } from 'vuelidate/lib/validators'

const hasDuplicates = function () {
  const val = [...new Set(this.form.origenes.map(a => `${a.tipoDocumentoId}${a.numberDocumento}`))].length === this.form.origenes.length
  return val
}

export default {
  mixins: [lmSuperPowerSelectHelper, lmToasts, lmFormatBytes],
  components: {
    LmForm,
    LmTextArea,
    LmTextInput,
    LmSuperPowerSelect,
    LmButton,
    lmConfirmationModal,
    LmEditor,
    LmNumberInput,
    LmSuggestionModal,
    LmUploadFiles,
    draggable,
    LmTreeSelect
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      dropzoneErrors: [],
      tomeConocimiento: [],
      refrenda: [],
      filePreview: null,
      anexosModalFile: {
        src: '',
        name: ''
      },
      isHideDzSuccess: false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        addRemoveLinks: true,
        acceptedFiles: 'application/pdf'
      },
      lmUploadFiles: [],
      observacionesButtonText: 'Ver observaciones',
      lmSuperPowerSelects: {
        clasificacion: {
          selectOptions: [],
          tbColumns: [
            { title: 'Clasificación', data: 'name' }
          ]
        },
        subclasificacion: {
          selectOptions: [],
          tbColumns: [
            { title: 'Subclasificación', data: 'name' }
          ]
        },
        tipoDocumento: {
          selectOptions: [],
          tbColumns: [
            { title: 'Documento', data: 'name' }
          ]
        },
        refrenda: {
          selectOptions: [],
          tbColumns: [
            { title: 'Refrenda', data: 'name' }
          ]
        },
        tomeConocimiento: {
          selectOptions: [],
          tbColumns: [
            { title: 'Tome Conocimiento', data: 'name' }
          ]
        },
        aniosExpedientesAsciados: {
          selectOptions: [],
          tbColumns: [
            { title: 'Año', data: 'name' },
            { title: '(Cant.)', data: 'count' }
          ]
        }
      },
      form: {
        titulo: '',
        idClasificacion: null,
        idSubclasificacion: null,
        origenes: [],
        articulos: [{ articuloContent: '' }],
        numeroExpedienteAsociado: '',
        seccionVisto: '',
        seccionConsiderando: '',
        seccionFinal: 'Es por ello que EL INTENDENTE MUNICIPAL DE VICENTE LOPEZ, en uso de las atribuciones que le son propias',
        refrenda: [],
        tomeConocimiento: [],
        permiteGuardar: !this.isOnEditMode,
        permiteVisar: false,
        permiteFirmar: false,
        permiteVerHistorial: false,
        permitePrevisualizar: false,
        permiteCompartir: false,
        compartir: false,
        steps: {
          items: [],
          position: 0,
          progress: 0
        },
        anexos: []
      },
      observaciones: {
        total: 0,
        items: []
      },
      initialForm: {},
      formIsProcessing: false,
      requireAllFields: false
    }
  },
  computed: {
    titulo: {
      get () {
        return this.isOnEditMode ? 'Editar' : 'Nuevo Decreto'
      },
      set () {}
    },
    stepsDirection: {
      get () {
        return this.form.steps.items.length > 6 ? 'vertical' : 'horizontal'
      },
      set () {}
    },
    pdfViewerColumns: {
      get () {
        return this.stepsDirection === 'vertical' ? 'col-sm-12 col-md-10' : 'col-12'
      },
      set () {}
    },
    pdfViewerHeight: {
      get () {
        const stepsDirection = this.stepsDirection
        if (stepsDirection === 'vertical') {
          return '100%'
        } else {
          return window.innerHeight - 200
        }
      },
      set () {}
    }
  },
  validations () {
    return {
      form: {
        titulo: {
          required
        },
        // idClasificacion: {
        //   required
        // },
        // idSubclasificacion: {
        //   required: requiredIf(function () {
        //     return this.form.idClasificacion
        //   })
        // },
        seccionVisto: {
          required: requiredIf(function () {
            return this.requireAllFields
          })
        },
        seccionConsiderando: {
          required: requiredIf(function () {
            return this.requireAllFields
          })
        },
        articulos: {
          minLength: minLength(1),
          $each: {
            articuloContent: {
              required: requiredIf(function () {
                return this.requireAllFields
              })
            }
          }
        },
        origenes: {
          hasDuplicates,
          $each: {
            tipoDocumentoId: {
              required: requiredIf(function () {
                return this.form.origenes.length > 0
              })
            },
            numberDocumento: {
              required: requiredIf(function () {
                return this.form.origenes.length > 0
              })
            }
          }
        },
        anexos: {
          maxLength: maxLength(this.anexosLimit)
        }
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true,
      default: '/'
    },
    newOrEditEndpointUri: {
      type: String,
      required: true
    },
    isOnEditMode: {
      type: Boolean,
      required: true,
      default: false
    },
    jnlpGeneratorPath: {
      type: String,
      required: true
    },
    anexosLimit: {
      type: Number,
      required: false,
      default: 40
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    inputRefrenda (e) {
      let refrenda = []
      _.forEach(e, (value) => {
        refrenda.push({ id: `${value.id}` })
      })
      this.form.refrenda = refrenda
    },
    inputTomeConocimiento (e) {
      let conocimiento = []
      _.forEach(e, (value) => {
        conocimiento.push({ id: `${value.id}` })
      })
      this.form.tomeConocimiento = conocimiento
    },
    inputTipoDocumento (index, e) {
      this.form.origenes[index].tipoDocumentoId = e.id
    },
    valueTipoDocumento (index) {
      let tipoDocumento = null
      if (this.form.origenes[index].tipoDocumentoId) {
        tipoDocumento = { id: this.form.origenes[index].tipoDocumentoId, name: this.form.origenes[index].tipoDocumentoId }
      }
      return tipoDocumento
    },
    setAnexosModalFile (file) {
      this.anexosModalFile.src = process.env.VUE_APP_API_URL_STATIC_ASSETS + file.path
      this.anexosModalFile.name = file.originalname
    },
    deleteUploadFile (index) {
      this.form.anexos.splice(index, 1)
      this.lmUploadFiles.splice(index, 1)
    },
    fileCreated (file, response) {
      if (response) {
        this.isHideDzSuccess = false
        this.form.anexos.push(response)
        setTimeout(() => {
          this.isHideDzSuccess = true
        }, 1000)
      }
    },
    fileRemoved (file, error, xhr) {
      this.form.urlimagen = ''
      if (file) {
        this.form.anexos = this.form.anexos.filter(f => f.name !== file.name)
        this.$forceUpdate()
      }
    },
    dropzoneErrorHandler (file) {
      const error = {
        variant: '',
        message: ''
      }
      if (file?.xhr?.status === 413) {
        const maxValueAllowedByServe = JSON.parse(file?.xhr?.response).message.match(/\d+/g)[0]
        error.message = `Lo sentimos, el tamaño del archivo "${file.name}" excede el tamaño máximo permitido ${this.formatBytes(maxValueAllowedByServe)}`
        error.variant = 'danger'
      } else if (file.type !== 'application/pdf') {
        error.message = 'Lo sentimos, sólo puede subir archivos en formato PDF'
        error.variant = 'warning'
      } else {
        error.message = file?.xhr?.response ? JSON.parse(file?.xhr?.response).message : ''
        error.variant = 'danger'
      }
      this.$refs.lmUploadFiles.lmRemoveFile(file)
      this.dropzoneErrors.push(error)
    },
    async setForm () {
      if (this.isOnEditMode) {
        this.$refs.lmFormRef.activeEditMode({
          path: 'decretos/edit/',
          id: this.$route.params.id
        })
          .then(response => {
            let tomeConocimiento = []
            _.forEach(this.form.tomeConocimiento, function (value, key) {
              tomeConocimiento.push({ id: value })
            })
            // Se comenta por bug resuelto en deploy 14-12-2021, pareciera no ser necesario
            // asociarle name a los componentes seleccionados de un treeselect.
            // let tomeConocimientoWithName = []
            // tomeConocimiento.forEach((res, key) => {
            //   let filter = this.lmSuperPowerSelects.tomeConocimiento.selectOptions.filter(word => word.id.toString() === tomeConocimiento[key].id)
            //   tomeConocimientoWithName.push(filter[0])
            // })
            this.tomeConocimiento = tomeConocimiento
            this.form.tomeConocimiento = tomeConocimiento
            let refrenda = []
            _.forEach(this.form.refrenda, function (value, key) {
              refrenda.push({ id: value })
            })
            this.refrenda = refrenda
          })
          .catch(error => {
            console.log(error)
            this.$router.replace({ name: '404' })
          })
        this.observaciones = await commonsApi.getItemDetail({
          path: 'decretos/observaciones',
          id: this.$route.params.id
        })
          .catch(error => {
            console.log(error)
            return {
              total: 0,
              items: []
            }
          })
      } else {
        this.$nextTick(function () {
          this.tomeConocimiento = []
          this.refrenda = []
          /*
          this.$refs.lmEditor[0].editor.commands.clearContent()
          this.$refs.lmEditorSeccionVisto.editor.commands.clearContent()
          this.$refs.lmEditorSeccionConsiderando.editor.commands.clearContent()
          */
        })
        this.form = JSON.parse(this.initialForm)
        this.form.permiteGuardar = true
        this.form.permiteVisar = true
        this.form.permitePrevisualizar = true
      }
      try {
        const endpointShared = 'decretos/compartir/'
        const canBeShared = await commonsApi.axiosGetWrapper(endpointShared)
        this.form.permiteCompartir = canBeShared.data
        const response = await this.getAllLmSuperPowerSelectOptions(
          [
            { name: 'clasificacion',
              obj: {
                path: 'clasificaciones/decretos/todas/',
                total: 1000
              }
            },
            { name: 'tipoDocumento',
              obj: {
                path: 'codificaciones/decretos/tipos_documentos/',
                total: 1000
              }
            },
            { name: 'refrenda',
              obj: {
                path: 'oficinas/secretarias/',
                exclude_me: true,
                total: 1000
              }
            },
            { name: 'tomeConocimiento',
              obj: {
                path: 'oficinas/secretarias/',
                total: 1000
              }
            }
          ])
        for (const e of response) {
          this.lmSuperPowerSelects[e.name].selectOptions = e.data
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    updateClasificacion (values) {
      if (values.length) {
        this.form.idClasificacion = values[0].id
      } else {
        this.form.idClasificacion = null
        this.lmSuperPowerSelects.subclasificacion.selectOptions = []
      }
    },
    updateSubclasificacion (values) {
      if (values.length) {
        this.form.idSubclasificacion = values[0].id
      } else {
        this.form.idSubclasificacion = null
      }
    },
    updateTipoDocumento (values, documentoIndex) {
      let value = values[0]
      this.form.origenes[documentoIndex].tipoDocumentoId = value ? value.id : null
    },
    updateRefrenda (values) {
      this.form.refrenda = values.map(i => {
        return {
          id: i.id
        }
      })
    },
    updateTomeConocimiento (values) {
      this.form.tomeConocimiento = values.map(i => {
        return {
          id: i.id
        }
      })
    },
    goBackBtn () {
      this.$router.go(-1)
    },
    cancelBtn () {
      this.$router.go(-1)
    },
    goToMovementsBtn () {
      this.$router.push(`/decretos/movements/${this.$route.params.id}`)
    },
    async save () {
      this.requireAllFields = false
      this.submit()
    },
    async enviaraVisar () {
      try {
        this.requireAllFields = true
        await this.$refs.lmFormRef.validationForm(this.$v)
        await this.$refs.lmConfirmationModalVisado.lmShow()
        await this.submit('enviaravisar')
      } catch (error) {
        this.formIsProcessing = false
      }
    },
    async enviaraFirmar () {
      try {
        this.requireAllFields = true
        await this.$refs.lmFormRef.validationForm(this.$v)
        await this.$refs.lmConfirmationModalEnviaraFirmar.lmShow()
        await this.submit('enviarafirmar')
      } catch (error) {
        this.formIsProcessing = false
      }
    },
    async aprobarVisado () {
      try {
        this.formIsProcessing = true
        await this.$refs.lmConfirmationModalAprobar.lmShow()
        let response = await this.updateItemDetail({
          path: 'decretos/aprobarvisado/',
          data: {
            id: this.$route.params.id
          }
        })
        this.formIsProcessing = false
        if (response.id) {
          this.lmToastSuccessInternalLink(`/decretos/detail/${response.id}`, 'Ver Detalle', 'Decreto Enviado a firmar')
          this.$router.push('/decretos/todos')
        }
      } catch (error) {
        this.formIsProcessing = false
        console.log(error)
      }
    },
    async rechazarVisado () {
      try {
        this.formIsProcessing = true
        const suggestionResponse = await this.$refs.LmSuggestionModal.lmShow()
        let response = await this.updateItemDetail({
          path: 'decretos/rechazarvisado/',
          data: {
            id: this.$route.params.id,
            reason: suggestionResponse.content
          }
        })
        this.formIsProcessing = false
        if (response.id) {
          this.lmToastSuccessInternalLink(`/decretos/detail/${response.id}`, 'Ver Detalle', 'Decreto Rechazado')
          this.$router.push('/decretos/todos')
        }
      } catch (error) {
        this.formIsProcessing = false
        console.log(error)
      }
    },
    async rechazarFirmado () {
      try {
        this.formIsProcessing = true
        const suggestionResponse = await this.$refs.LmSuggestionModal.lmShow()
        let response = await this.updateItemDetail({
          path: 'decretos/rechazarfirmado/',
          data: {
            id: this.$route.params.id,
            reason: suggestionResponse.content
          }
        })
        this.formIsProcessing = false
        if (response.id) {
          this.lmToastSuccessInternalLink(`/decretos/detail/${response.id}`, 'Ver Detalle', 'Decreto Rechazado')
          this.$router.push('/decretos/firmar')
        }
      } catch (error) {
        this.formIsProcessing = false
        console.log(error)
      }
    },
    async tomarControlDecreto () {
      try {
        this.formIsProcessing = true
        await this.$refs.lmConfirmationModalTomarControl.lmShow()
        let response = await this.updateItemDetail({
          path: 'decretos/tomarcontrol/',
          data: {
            id: this.$route.params.id
          }
        })
        this.formIsProcessing = false
        if (response.id) {
          this.setForm()
          // window.location.reload()
          // this.key++
        }
      } catch (error) {
        this.formIsProcessing = false
        console.log(error)
      }
    },
    async firmarViaFirmador () {
      try {
        this.formIsProcessing = true
        await this.$refs.lmConfirmationModalFirmar.lmShow()
        this.formIsProcessing = false
        const tempLink = document.createElement('a')
        tempLink.href = `${this.jnlpGeneratorPath}${this.$route.params.id}`
        tempLink.setAttribute('download', `${this.mesa3}.jnlp`)
        tempLink.click()
        this.lmToastSuccessInternalLink(`/decretos/detail/${this.$route.params.id}`, 'Ver Detalle', 'Decreto enviado al firmador')
        setTimeout(() => {
          this.$router.push('/decretos/firmar')
        }, 1000)
      } catch (error) {
        this.formIsProcessing = false
        console.log(error)
      }
    },
    async vistaprevia () {
      this.formIsProcessing = false
      this.filePreview = ''
      let formData = {
        id: this.$route.params.id,
        titulo: this.form.titulo,
        idClasificacion: this.form.idClasificacion,
        idSubclasificacion: this.form.idSubclasificacion,
        origenes: this.form.origenes,
        visto: this.form.seccionVisto,
        considerando: this.form.seccionConsiderando,
        final: this.form.seccionFinal,
        articulos: this.form.articulos,
        refrenda: this.form.refrenda,
        tomeConocimiento: this.form.tomeConocimiento,
        compartir: this.form.compartir,
        anexos: this.form.anexos
      }
      let response = await this.updateItemDetail({
        path: 'decretos/preview/',
        data: formData
      })
      // const filePreview = await commonsApi.axiosGetWrapper('decretos/preview/', {
      //   params: {
      //     id: this.$route.params.id
      //   }
      // })
      this.filePreview = response
      // console.log('this.filePreview: ', this.filePreview)
      this.$refs['pdfViewerModal'].show()
    },
    async submit (accionLuegoDeGuardar = '') {
      try {
        let decretoId = false
        if (this.isOnEditMode) {
          await this.$refs.lmFormRef.validationForm(this.$v)
          this.formIsProcessing = true
          /**
           * Se persisten los datos
           */
          let tomeConocimiento = []
          _.forEach(this.form.tomeConocimiento, (value, key) => {
            tomeConocimiento.push({ id: value.id })
          })
          this.form.tomeConocimiento = tomeConocimiento
          let saveData = {
            id: this.$route.params.id,
            titulo: this.form.titulo,
            idClasificacion: this.form.idClasificacion,
            idSubclasificacion: this.form.idSubclasificacion,
            origenes: this.form.origenes,
            visto: this.form.seccionVisto,
            considerando: this.form.seccionConsiderando,
            final: this.form.seccionFinal,
            articulos: this.form.articulos,
            refrenda: this.form.refrenda,
            tomeConocimiento: this.form.tomeConocimiento,
            anexos: this.form.anexos,
            compartir: this.form.compartir
          }
          try {
            let response = await this.updateItemDetail({
              path: 'decretos/update/',
              data: saveData
            })
            if (response.id) {
              decretoId = response.id
            }
          } finally {
            this.formIsProcessing = false
          }
        } else {
          await this.$refs.lmFormRef.validationForm(this.$v)
          this.formIsProcessing = true
          /**
           * Se persisten los datos
           */
          let saveData = {
            titulo: this.form.titulo,
            idClasificacion: this.form.idClasificacion,
            idSubclasificacion: this.form.idSubclasificacion,
            origenes: this.form.origenes,
            visto: this.form.seccionVisto,
            considerando: this.form.seccionConsiderando,
            final: this.form.seccionFinal,
            articulos: this.form.articulos,
            refrenda: this.form.refrenda,
            tomeConocimiento: this.form.tomeConocimiento,
            anexos: this.form.anexos,
            compartir: this.form.compartir
          }
          try {
            let response = await this.updateItemDetail({
              path: 'decretos/new/',
              data: saveData
            })
            if (response.id) {
              decretoId = response.id
            }
            // if (accionLuegoDeGuardar === 'enviaravisar') {
            //   if (newDecretoId) {
            //     let response = await this.updateItemDetail({
            //       path: 'decretos/enviaravisar/',
            //       data: {
            //         id: newDecretoId
            //       }
            //     })
            //     this.formIsProcessing = false
            //     if (response.id) {
            //       this.lmToastSuccessInternalLink(`/decretos/detail/${response.id}`, 'Ver Detalle', 'Decreto Enviado a Visar')
            //       this.$router.push('/decretos/mios')
            //     }
            //   }
            // } else if (accionLuegoDeGuardar === 'firmar') {
            //   console.log('firmar')
            // } else {
            //   this.formIsProcessing = false
            //   if (newDecretoId) {
            //     this.lmToastSuccessInternalLink(`/decretos/detail/${newDecretoId}`, 'Ver Detalle', 'Nuevo Decreto Guardado')
            //   }
            //   this.$router.push('/decretos/mios')
            // }
          } finally {
            this.formIsProcessing = false
          }
        }

        try {
          this.formIsProcessing = true
          if (accionLuegoDeGuardar === 'enviaravisar') {
            if (decretoId) {
              let response = await this.updateItemDetail({
                path: 'decretos/enviaravisar/',
                data: {
                  id: decretoId
                }
              })
              this.formIsProcessing = false
              if (response.id) {
                this.lmToastSuccessInternalLink(`/decretos/detail/${response.id}`, 'Ver Detalle', 'Decreto Enviado a Visar')
                this.$router.push('/decretos/mios')
              }
            }
          } else if (accionLuegoDeGuardar === 'enviarafirmar') {
            if (decretoId) {
              let response = await this.updateItemDetail({
                path: 'decretos/enviarafirmar/',
                data: {
                  id: decretoId
                }
              })
              this.formIsProcessing = false
              if (response.id) {
                this.lmToastSuccessInternalLink(`/decretos/detail/${response.id}`, 'Ver Detalle', 'Decreto Enviado a Firmar')
                this.$router.push('/decretos/mios')
              }
            }
          } else {
            this.formIsProcessing = false
            if (decretoId) {
              let mensaje = ''
              if (this.isOnEditMode) {
                mensaje = 'Decreto Actualizado'
              } else {
                mensaje = 'Nuevo Decreto Guardado'
              }
              this.lmToastSuccessInternalLink(`/decretos/detail/${decretoId}`, 'Ver Detalle', mensaje)
              this.$router.push('/decretos/mios')
            }
          }
        } finally {
          this.formIsProcessing = false
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  watch: {
    '$route.path' () {
      this.setForm()
    },
    isOnEditMode () {
      this.setForm()
    },
    'form.idClasificacion' () {
      if (this.form.idClasificacion) {
        commonsApi.getSelectOptions({
          path: 'subclasificaciones/decretos/porclasificacion/',
          parentId: this.form.idClasificacion,
          total: 500
        })
          .then(response => {
            this.lmSuperPowerSelects.subclasificacion.selectOptions = response
          })
          .catch(error => {
            console.log('error: ', error)
          })
      }
    }
  },
  created () {
    this.initialForm = JSON.stringify(this.form)
    // console.log(JSON.stringify(this.initialForm, false, 4))
  },
  mounted () {
    this.setForm()
  }
}
</script>

<style lang="sass">
.modal-huge
  max-width: 75%
  width: 75%
</style>

<style lang="sass" scoped>
#decretos-new-or-edit
  .lm-collapse
    top: 35px
    right: 0
    z-index: 1
  .observaciones-button
    min-width: 163px
  .estado-decreto
    h2
      margin-bottom: 40px
    margin-top: 20px
    margin-bottom: 40px
  .collapsing
    transition: none
  .close
    cursor: pointer
    font-size: 20px
  .bar
    cursor: grab
    font-size: 20px
  .f-icon
    top: 3px
    position: relative
  .file-name
    width: 50%
    @media(min-width: $lg)
      width: 70%
  .file-size
    line-height: 1.5
  #pdfViewer
    min-height: 500px
</style>
